import React,{useLayoutEffect} from "react";
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    breadcrumbsPropTypes,
    matchPropTypes,
  } from '../../../common/resource/proptypes/CommonPropTypes';
import { CITY_PATH } from "../../../../config/paths";
import Content from "../../../layout/Content";
import CityToolbar from "./CityToolbar";
import { clearCity, getCity } from "../../../../actions";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import CityBasicInformationResource from './resource/CityBasicInformationResource';

export const City = ({
  breadcrumbs,
  match: {
    params: { id },
  },
  city,
  loading,
  dispatchGetCity,
  dispatchClearCity,
}) => {
  useLayoutEffect(() => {
    dispatchGetCity({ id });
    return () => dispatchClearCity();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (city.isEmpty())
    content = <NoDataResource returnPage={CITY_PATH} />;
  else {
    const cityJson = city.toJS();
    content = <CityBasicInformationResource city={cityJson} />;
    toolbar = <CityToolbar cityId={cityJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Ciudad"
      content={content}
    />
  );
};

City.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetCity: PropTypes.func.isRequired,
  dispatchClearCity: PropTypes.func.isRequired,
  city: PropTypes.instanceOf(Immutable.Map).isRequired,
  match: matchPropTypes.isRequired,
  loading: PropTypes.bool,
};

const mapDispatchToProps = {
  dispatchGetCity: getCity,
  dispatchClearCity: clearCity,
};


City.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ LocationUnit }) => ({
  breadcrumbs: [
    ...LocationUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Ciudades',
      href: CITY_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  city: LocationUnit.City.getIn(['current', 'content']),
  loading: !LocationUnit.City.getIn(['current', 'activity']).isEmpty(),
});


export default connect(mapStateToProps, mapDispatchToProps)(City);